const STATUS_MESSAGES = {
  400: 'We could not process your request. Please check your input.',
  401: 'Your session has expired. Please sign in again.',
  403: 'You do not have permission to do that.',
  404: 'We could not find what you requested.',
  409: 'This item already exists or is in use.',
  413: 'File is too large. Please upload a smaller file.',
  422: 'We could not validate your input.',
  429: 'Too many requests. Please try again soon.'
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  const status = error?.response?.status;
  const serverMsg = error?.response?.data?.message || error?.response?.data?.error;

  if (serverMsg) {
    return serverMsg;
  }

  if (status && STATUS_MESSAGES[status]) {
    return STATUS_MESSAGES[status];
  }

  if (typeof status === 'number' && status >= 500) {
    return 'Something went wrong on our side. Please try again later.';
  }

  if (error?.code === 'ECONNABORTED') {
    return 'Request timed out. Please try again.';
  }

  if (!error?.response) {
    return 'Network error. Please check your connection.';
  }

  return fallbackMessage || 'Something went wrong. Please try again.';
};

export default getApiErrorMessage;
